import React from 'react';
import ServiceRecovery from '../../components/PublicSite/ServiceRecovery';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';
import loadSiteCopy from '../../components/PublicSite/loadSiteCopy';

async function action() {
  await loadSiteCopy();
  return {
    title: 'Car Recovery & Towing in the UAE — 24/7 | Bas Recovery',
    description: 'Flatbed and wheel-lift recovery anywhere in the UAE, 24 hours a day. From AED 300, fixed price quoted before we dispatch. Call 050 505 2213.',
    component: (
      <HeadLessLayout>
        <ServiceRecovery />
      </HeadLessLayout>
    ),
  };
}

export default action;
